import { PartnerExpoStand } from 'elements/hardwareSelectorV2/types'
import { ComponentVersionsInherit, Link, OsTooltipVersion, styled, Typography } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { FC } from 'react'
import { ToolTipRestyle } from 'resources/projects/projects3/styles'
import SeeMoreRibbon from './PremiumSeeMoreRibbonTag'

const PremiumExpoTooltip: FC<PartnerExpoStand> = (props) => {
  return (
    <ComponentVersionsInherit versions={{ tooltip: OsTooltipVersion.V2 }}>
      <ToolTipRestyle
        color="primary"
        title={<PremiumTipContent {...props} />}
        placement={'top'}
        arrow
        interactive
        leaveDelay={300}
        enterDelay={300}
      >
        <div>
          <SeeMoreRibbon />
        </div>
      </ToolTipRestyle>
    </ComponentVersionsInherit>
  )
}

const TooltipCTAButton = styled('div', { name: 'TooltipCTAButton' })(({ theme }) => ({
  textDecoration: 'underline',
  marginTop: theme.spacing(1),
}))

const PremiumTipContent: FC<PartnerExpoStand> = ({ slug }) => {
  const translate = useTranslate()
  return (
    <>
      <Typography textVariant="caption1Bold" colorHex="white">
        {translate('Premium Partner')}
      </Typography>
      <Typography textVariant="caption1" colorHex="white">
        {translate("Get detailed information on this product by visiting the partner's expo stand.")}
      </Typography>
      <TooltipCTAButton>
        <Link target="_blank" rel="noopener noreferrer" href={'/expo/' + slug}>
          {translate('Visit Stand')}
        </Link>
      </TooltipCTAButton>
    </>
  )
}

export default PremiumExpoTooltip
